import React, { Component } from 'react';
import { Button, Modal } from 'carbon-components-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { insertDmService, getDmService } from '../../../../services/Api';
import UnidAndStores from '../../../../components/trades/UnitsAndStores';
import { Card } from '../../../../components';

class ConfirmExchangeClipboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stores: [],
      selectedUnit: null,
      selectedStore: null,
      currentDate: null,
      numberRequest: null,
      modalConfirm: false,
      reason: null,
    };
  }

  componentWillMount() {
    this.setDateNow();
  }

  setDateNow = () => {
    this.setState({
      currentDate: moment().format('DD/MM/YYYY'),
    });
  };

  openModal = () => {
    this.setState({
      modalConfirm: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalConfirm: false,
    });

    window.location.href = '/trade/pranchetas';
  };

  getReason = value => {
    this.setState({
      reason: value,
    });
  };

  postClipboards = () => {
    const { selectedUnit, selectedStore, reason } = this.state;
    const { orderId } = this.props;
    if (selectedUnit && selectedStore && reason) {
      const { cleark } = this.props;
      const urlEdit = '/Pedido/GeraPedidoMaterial';
      const formData = {
        TipoCadastro: { id: 4 },
        TipoAssistente: { id: 2 },
        Atendente: { id: cleark.id },
        PedidoPai: orderId,
        Unidade: { Id: selectedUnit.id },
        Loja: { Id: selectedStore.id },
        MotivoTroca: reason,
      };

      insertDmService(urlEdit, formData)
        .then(res => {
          this.setState({ numberRequest: res });
          this.openModal();
        })
        .catch(err => {
          toast.warn('Um erro inesperado ocorreu. Tente novamente mais tarde.');
          console.log(err);
        });
    } else {
      toast.warn('Todos os campos devem ser preenchidos');
    }
  };

  loadStores = async unitId => {
    const { cleark } = this.props;
    try {
      const data = await getDmService(`/Atendente/GetLojas/${cleark.id}?idUnidade=${unitId}`);
      const arrStores = [];
      data.forEach(item => {
        arrStores.push({
          id: item.id,
          label: item.nome,
        });
      });

      this.setState({
        stores: arrStores,
      });
    } catch (error) {
      console.error(error);
    }
  };

  onChangeUnit = obj => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      // error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({
      selectedStore: obj,
      // error: null,
    });
  };

  render() {
    const { cleark, returnSearch, dateOrder } = this.props;
    const {
      stores,
      selectedUnit,
      selectedStore,
      currentDate,
      numberRequest,
      modalConfirm,
    } = this.state;
   

    return (
      <Card className="center-box box-padd">
        <div className="bx--row">
          <div className="bx--col-xs-12">
            <p className="description-option-title ">Confirme sua solicitação de prancheta</p>
            <p className="description-option-desc">
              Você tem certeza que deseja socilitar uma prancheta para a atendente
              {' '}
              <strong>
                {' '}
                {cleark.label}
                {' '}
              </strong>
              {' '}
              ?
            </p>
            <div className="mg-top-40 confirm-troca">
              <p className="mg-top-20 color-red">
                <strong>Prancheta </strong>
                {' '}
                <span className="line-through">
                  {' '}
                  {currentDate}
                  {' '}
                </span>
              </p>
              <p>Por</p>
              <p className="color-green">
                <strong>Prancheta </strong>
                {' '}
                <span>
                  {' '}
                  {moment(dateOrder).format('DD/MM/YYYY')}
                  {' '}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-xs-12">
            <div className="bx--form-item mg-top-40">
              <textarea
                id="text-area-2"
                className="bx--text-area"
                onChange={e => this.getReason(e.target.value)}
                rows="4"
                cols="50"
                placeholder="Digite aqui"
              />
              <label htmlFor="text-area-2" className="bx--label">
                {' '}
                Motivo da Troca
                {' '}
              </label>
            </div>
          </div>
        </div>
        <div className="bx--row">
          <div className="stores-units-trades bx--col-xs-12">
            <h2>Qual a loja principal deste atendente.</h2>
            <p>
              Selecione abaixo a loja principal de
              {' '}
              <span>
                {' '}
                {cleark.label}
                {' '}
              </span>
            </p>
            <div className="mg-top-20">
              <UnidAndStores
                onChangeStore={this.onChangeStore}
                onChangeUnit={this.onChangeUnit}
                stores={stores}
                urlUnits={`/Atendente/GetUnidades/${cleark.id}`}
                selectedUnit={selectedUnit}
                selectedStore={selectedStore}
              />
            </div>
          </div>
        </div>

        <div className="bx--row">
          <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
            <Button onClick={() => this.postClipboards()}> Finalizar Pedido </Button>
            <Button kind="ghost" onClick={returnSearch} className="h-sm-margin">
              Voltar
            </Button>
          </div>
        </div>

        <Modal
          onRequestClose={() => this.closeModal()}
          onRequestSubmit={() => this.closeModal()}
          iconDescription="Fechar"
          className="some-class confirm-trade"
          open={modalConfirm}
          modalHeading="Pedido feito com sucesso."
          primaryButtonText="Ok, Entendi"
        >
          <div className="warning-modal-txt">
            <p>
              <strong>
                {`Seu pedido ${numberRequest} está sob avaliação.`}
              </strong>
            </p>
            <p className="finalizado-pedido">
              A qualquer momento você poderá acompanhá-lo clicando em
              {' '}
              <a className="notifications pointer" href="/pedidos">
                <i className="assignment" />
              </a>
            </p>
          </div>
        </Modal>
      </Card>
    );
  }
}

export default ConfirmExchangeClipboard;



// WEBPACK FOOTER //
// ./src/screens/client/trades/clipboards/ConfimExchangeClipboard.jsx